import { useEffect, useState } from "react";
import { BookOpen, Search, Clock } from "lucide-react";
import GradientBg from "@/components/common/GradientBg";
import api from "@/lib/api";

export default function KnowledgeBase() {
  const [articles, setArticles] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/public/kb").then((r) => setArticles(r.data.articles));
  }, []);

  const filtered = articles.filter((a) => a.title.toLowerCase().includes(q.toLowerCase()));

  const grouped = filtered.reduce((acc, a) => {
    (acc[a.category] = acc[a.category] || []).push(a);
    return acc;
  }, {});

  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-4xl px-6 pt-24 pb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Knowledge base</div>
        <h1 className="mt-3 text-5xl md:text-6xl font-black tracking-tight">Guides & documentation</h1>
        <p className="mt-4 text-muted-foreground max-w-xl">
          Get up to speed fast with our hand-crafted docs — from your first login to advanced tuning.
        </p>

        <div className="mt-10 relative">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search articles…"
            data-testid="kb-search"
            className="w-full rounded-full bg-muted/40 border border-border pl-11 pr-4 py-3 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
          />
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-24 space-y-10">
        {Object.entries(grouped).map(([cat, items]) => (
          <div key={cat}>
            <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground font-bold mb-4">{cat}</div>
            <div className="space-y-2">
              {items.map((a) => (
                <a
                  key={a.slug}
                  href="#"
                  data-testid={`kb-article-${a.slug}`}
                  className="flex items-center justify-between surface px-5 py-4 hover:border-primary/40 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <BookOpen size={16} className="text-primary" />
                    <span className="font-semibold">{a.title}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                    <Clock size={12} /> {a.read_min} min read
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
